// extracted by mini-css-extract-plugin
export default {"container":"styles_container__X-omB","container__mobile":"styles_container__mobile__R6QGe","container__input":"styles_container__input__g4CwY","label":"styles_label__8mDp2"};